import { EmailValidationTemplate } from '@/templates/EmailValidation'

const EmailValidation = (): JSX.Element => {
  return <EmailValidationTemplate />
}

export default EmailValidation
